import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccordionComponent, AccordionItem } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { Subscription } from 'rxjs';
import { DataScopesEnum } from '../../shared/enums/dataScopes.enum';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICustomer, IRevisionHistory, IServiceError } from '../../shared/models/index';
import { DeviceinventoryService, StorageManagerService } from '../../shared/services/index';

@Component({
    selector: 'app-submission-history-item',
    templateUrl: './submission-history-item.component.html',
    styleUrls: ['./submission-history-item.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class SubmissionHistoryItemComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {

  userGuid: string;
  customer: ICustomer;
  itemUdi: string;
  itemIssuingAgency: string;
  revisions: IRevisionHistory[] = [];
  visible = false;
  resolverData: any[] | IServiceError;
  deviceMapping: any;
  mapArray = [];
  itemData: any;
  documentId: string;
  dataScope: string;
  defaultPropsArray: string[] = [];
  readOnly = true;
  udiDI: string;
  budi: string;
  agency: string;
  productSKU: string;
  revision: string;
  itemType: string;
  modelBUDI: string;
  modelAgency: string;
  headerVar: string;
  dataScopesEnum: any;
  sppModel = false;
  sppDevice = false;
  subscription: Subscription;
  accordionItemsData: any = [];
  public mapping = { header: 'header', content: 'content' };

  @ViewChild('dialog')
  public dialog: DialogComponent;

  @ViewChild('properties') accordionObj: AccordionComponent;

  itemTemplate: string;
  submissionHistoryItem = false;

  eudamedId: string;
  eudamedIdIssuingAgency: string;
  eudamedDi: string;
  eudamedDiIssuingAgency: string;
  showLegacy: boolean;
  applicableRegulation: string;

  public btnClick: EmitType<object> = () => {
    this.dialog.show();
  }

  constructor (private activatedRoute: ActivatedRoute, private storage: StorageManagerService, private router: Router, private deviceInventoryService: DeviceinventoryService, private cdref: ChangeDetectorRef, private appGlobals: AppGlobals) { }

  ngOnInit() {

    this.dataScopesEnum = DataScopesEnum;
    //Defaulting legacyData to false
    this.showLegacy = false;
    // Get user and customer
    this.getPrincipals();

    this.getResolverData();

    if (this.itemData && Object.keys(this.itemData).length) {
      this.udiDI = this.itemData.udiDI;
      this.agency = this.itemData.udiDiIssuingAgency;
      this.revision = this.itemData.revision;
      this.budi = this.itemData.budiDI;
      this.modelAgency = this.itemData.budiDiIssuingAgency;
      // productSKU comes from the device/model level. Need to check for default
      this.productSKU = this.displayItemData('Product SKU');

      // displayItemData is used to get a correct "blank override" value from either a default or eudamed. this.sppModel is used as a flag on the item details to display either a MNR SRN or SPP SRN for a MODEL. The value of this attribute is set on the form further below.
      this.sppModel = !!this.displayItemData('System or Procedure Pack Producer SRN');

      // check if Device is a SPP. This variable is an Input parameter for the accordion.
      // this.sppModel is used as a flag FOR A DEVICE and it's taken from the grid because the device details doesn't have this Model's attribute. For the Device we are not interested in the value but just the fact that the Device's model is a SPP
      const item = this.storage.read('sh-item');

      if (item) {
        this.sppDevice = !!item.systemProcedurePackSrn;
        this.applicableRegulation = item.applicableLegislation ? item.applicableLegislation.toUpperCase() : '';
      }

      //Legacy
      this.modelBUDI = this.displayItemData('BUDI-DI');
      this.eudamedId = this.itemData.eudamedID;
      this.eudamedIdIssuingAgency = this.displayItemData('Eudamed ID Issuing Agency');
      this.eudamedDi = this.displayItemData('Eudamed DI');
      this.eudamedDiIssuingAgency = this.displayItemData('Eudamed DI Issuing Agency');
  
    }
  }

  private getResolverData() {

    if (this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.itemData.length) {

      // Device mapping
      if (this.activatedRoute.snapshot.data.itemData[1] && this.activatedRoute.snapshot.data.itemData[0] !== 'error') {
        this.deviceMapping = this.activatedRoute.snapshot.data.itemData[0];

        Object.keys(this.deviceMapping).map(e => {

          this.mapArray.push({ key: e, value: this.deviceMapping[e] });
        });

        if (this.activatedRoute.snapshot.data.itemData[1].data && this.activatedRoute.snapshot.data.itemData[1].isSuccess) {

          // mock file
          // this.deviceInventoryService.getSubmissionItemMock().subscribe(mock => {
          //   this.itemData = mock;
          //   this.itemType = this.itemData.documentType;
          //   this.headerVar = this.itemType === 'model' ? 'Model' : 'Device';
          // });

          this.itemData = this.activatedRoute.snapshot.data.itemData[1].data.result[0];
          this.itemType = this.itemData.documentType;
          this.headerVar = this.itemType === 'model' ? 'Model' : 'Device';
    
          // If legacy data is present then change the header
          if (this.dataScope.toLowerCase() === 'eudamed' || this.dataScope.toLowerCase() === 'swissdamed') {              
            if (this.itemData.hasOwnProperty('eudamedID') || this.itemData.hasOwnProperty('eudamedDI')) {
              this.headerVar = this.itemType === 'model' ? 'Legacy Model' : 'Legacy Device';
              this.showLegacy = true;
            }             
          }          

        } else {
          this.router.navigate(['error', { message: this.appGlobals.GENERIC_ERROR_MSG }]);
        }
      }
    }
  }

  displayItemData(field: string): string {

    let retVal: any;
    let prop: any;
    let propValue: string;
    let itemValuePath = [];
    let itemPropsPathSegment: any;
    let defaultPropsPathSegment: any;

    if (this.itemData && field) {

      prop = this.mapArray.find(p => p.key.toLowerCase() === field.toLowerCase());

      if (prop) {
        propValue = prop.value;

        if (propValue) {

          // Multi path value
          if (propValue.indexOf('/') > -1) {

            if (propValue.indexOf('<dataScope>') > -1) {

              propValue = propValue.replace('<dataScope>', this.dataScope);
            }

            if (propValue.indexOf('<documentType>') > -1) {

              propValue = propValue.replace('<documentType>', this.itemType + 'Data');
            }

            itemValuePath = propValue.split('/');

            if (itemValuePath && itemValuePath.length > 0) {

              // Top level item data
              itemPropsPathSegment = this.itemData;

              // Get Default settings to be able to use it if there is no data for the dataScope.
              defaultPropsPathSegment = this.itemData;

              itemValuePath.forEach(path => {

                // if dataScope segment or value is undefined check if it exists in Default.
                if (itemPropsPathSegment && Object.keys(itemPropsPathSegment).length) {

                  itemPropsPathSegment = itemPropsPathSegment[path];

                  if (path.toLowerCase() === this.dataScope.toLowerCase()) {
                    path = 'default';
                  }

                  if (defaultPropsPathSegment) {
                    defaultPropsPathSegment = defaultPropsPathSegment[path];
                  }

                } else {
                  if (defaultPropsPathSegment) {
                    if (!Array.isArray(defaultPropsPathSegment)) {
                      defaultPropsPathSegment = defaultPropsPathSegment[path];
                    }
                  }
                }
              });
            }

            // should allow the blank space so testing it against the undefined
            if (itemPropsPathSegment !== undefined && itemPropsPathSegment !== null) {

              if (typeof itemPropsPathSegment === 'object' && !Object.keys(itemPropsPathSegment).length) {
                itemPropsPathSegment = '';
              }

              retVal = itemPropsPathSegment;
            } else {

              retVal = defaultPropsPathSegment;

              if (defaultPropsPathSegment) {
                this.defaultPropsArray.push(field);
              }
            }
          } else {

            // Single path value
            retVal = this.itemData[propValue];
          }
        }
      }
    }

    return retVal;
  }

  isDefault(field: string): string {

    return this.defaultPropsArray.includes(field) ? 'highlight-fill' : '';
  }

  private getPrincipals() {

    // Get the userGuid
    this.userGuid = this.storage.read('userGuid');

    if (!this.userGuid) {
      this.router.navigate(['error', 'User is not logged in']);
    }

    // Get the current Customer
    const customer = this.storage.read('currentCustomer');

    if (customer) {

      this.customer = typeof customer === 'object' ? customer : <ICustomer>JSON.parse(customer);
    } else {
      this.router.navigate(['/home']);
    }

    this.dataScope = this.storage.read('dataScope');
  }

  accordionCreated(event) {

    this.accordionObj.items[0].expanded = true;

    this.accordionObj.refresh();
  }

  ngAfterViewInit(): void {

    this.visible = false;
  }

  collapseAll() {

    this.accordionObj.items.forEach((i: AccordionItem) => {

      this.accordionObj.expandItem(false);
    });
  }

  expandAll() {

    this.accordionObj.items.forEach((i: AccordionItem) => {

      this.accordionObj.expandItem(true);
    });
  }

  ngAfterContentChecked() {

    this.cdref.detectChanges();
  }

  returnToList() {

    this.storage.remove('sh-item');
    this.router.navigate(['/submissions/submissionhistory']);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  showModelClinicalInvestigationSection(): boolean {
    if (this.sppModel) {
      return false;
    }

    const currentDataScope = (this.dataScope || '').toLowerCase();

    if (currentDataScope === DataScopesEnum.EUDAMED.toLowerCase()) {
      return true;
    }

    if (currentDataScope === DataScopesEnum.SWISSDAMED.toLowerCase()) {
      return ['MDD', 'AIMDD', 'IVDD', 'MDD-AIMDD'].includes(this.getModelApplicableRegulation());
    }

    return false;
  }

  showDevicePackagingSection(): boolean {
    return !this.isSwissdamedLegacyDeviceRegulation() && !this.isSwissdamedIvddDeviceRegulation();
  }

  getModelClinicalInvestigationHeader(): string {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase()
      ? ' Certificate Links '
      : ' Clinical Investigation and Certificate Links ';
  }

  private getModelApplicableRegulation(): string {
    const modelData = this.itemData?.modelData;
    const currentDataScope = (this.dataScope || '').toLowerCase();
    const scopedModelData = currentDataScope ? modelData?.[currentDataScope] : null;

    if (scopedModelData?.applicableRegulation) {
      return scopedModelData.applicableRegulation.toUpperCase();
    }

    if (modelData?.default?.applicableRegulation) {
      return modelData.default.applicableRegulation.toUpperCase();
    }

    return '';
  }

  private isSwissdamedLegacyDeviceRegulation(): boolean {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase() &&
      ['MDD', 'AIMDD', 'MDD-AIMDD'].includes((this.applicableRegulation || '').toUpperCase());
  }

  private isSwissdamedIvddDeviceRegulation(): boolean {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase() &&
      (this.applicableRegulation || '').toUpperCase() === 'IVDD';
  }

}
